module.exports = __webpack_public_path__ + "static/mirvac_logo-e8ddde51d6470fa86205ee27f5d2852c.png";